import React, {
  useState,
  useEffect,
  useRef,
  createRef,
  useImperativeHandle,
  useContext,
} from "react";
import { Stage, Layer, Rect, Image, Group } from "react-konva";
import Vector, { getQuadrant, getSlope, getAngleDeg, getOffSetValueFromTouchEvent } from "./vectors";
import Point from "./point_vector";
import RulerLayer from "./ruler";
import Grid from "./grid";
import inPointVector from "../../images/vectors/in_point_charge.svg";
import outPointVector from "../../images/vectors/out_point_charge.svg";
import SFVectorClass from "./SFVectorClass";
import Victor from "victor";
import MathJaxPreview from "../react-mathjax-preview";
import { Checkbox, FormControlLabel, IconButton, Tooltip, Typography } from "@mui/material";
import ReactTooltip from 'react-tooltip';
import infoIcon from '../../images/png/infoIcon.png';
import {
  Button,
} from "react-md";
import { colorsArray } from "./commonHelpers";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { IoMdInformationCircle } from "react-icons/io";
import { MdRefresh } from "react-icons/md";
import { ReactSVG } from "react-svg";
import arrowSVG from "../../images/vectors/up-right-arrow.svg";
import { FaCircle } from "react-icons/fa";
import oDotImg from "../../images/png/o_dot.png"
import oTimesImg from "../../images/png/o_times.png"
import "./canvasStyle.css"

const PADDING = 0;
const gridLinesColors = { dark: '#000000', medium: '#BAC4C8', light: '#D4D4D4' };

import { downloadErrorInfo } from "../../components/vectors/commonHelpers"
import { DEFAULT_LATEX_SYMBOL, DEFAULT_LATEX_SYMBOL_SIZE, DEFAULT_VECTOR_SNAP_TO_GIRD, DEFAULT_ZERO_POINT_COLOR, DEFAULT_ZERO_POINT_RADIUS, SymbolType } from "../../common/constants";
import SFVectorInput from "../../SF/SFPages/SFTakequiz/components/SFVectorInput";
import SFTooltip from "../../SF/SFPages/SFTakequiz/components/SFTooltip";
import { IoInformationCircleSharp } from "react-icons/io5";
import { AppContext } from "../../AppContext";

export function QListCountArray(QList) {
  let CountArr = [];
  for (let i = 0; i < QList.length; i++) {
    CountArr.push(countInArray(QList, QList[i]))
  }
  return CountArr;
}

export function countInArray(array1, what) {
  var count = 0;
  for (var i = 0; i < array1.length; i++) {
    if (array1[i] === what) {
      count++;
    }
  }
  return count;
}

export function TwoQListCountArray(QList1, QList2) {
  let ConcatArr = []
  let CountArr = [];
  for (let i = 0; i < QList1.length; i++) {
    ConcatArr.push(`${QList1[i]}${QList2[i]}`)
  }
  for (let x = 0; x < ConcatArr.length; x++) {
    CountArr.push(countInArray(ConcatArr, ConcatArr[x]))
  }
  return CountArr;
}

const Canvas = React.forwardRef(
  (
    {
      height,
      width,
      rulerXPoint,
      rulerYPoint,
      enableGrid,
      enableBorder,
      enableRuler,
      stepSize,
      onVectorMoved,
      stepDeg,
      degStepSize,
      magStepSize,
      freeBodyDiagram,
      enableDarkGridLine,
      readOnly,
      fbdWidth,
      fbdHeight,
      fbdX,
      fbdY,
      gridColor,
      rulerXLabel,
      rulerYLabel,
      rulerNXLabel,
      rulerNYLabel,
      commonVectorSettings,
      vectorAnswerFormula,
      vectorAnswerFormulas,
      isAngleOrMagnitudeTextFieldChanged,
      handleAngleMagnitudeTextFieldChange,
      type,
      answerType,
      showQuestionVectorPrompt,
      showAnswerResponse,
      answerCorrect,
      isAnswer,
      showScale,
      scale,
      showVectorPrompt,

      questionShowComponents,
      questionShowMagnitudeAngle,
      currentQuestionID,
    },
    ref
  ) => {

    const appContext = useContext(AppContext);

    let isSnapToGrid = !commonVectorSettings.isSnapToGridOff;

    const blockSnapSize = stepSize ? stepSize : 5;
    const padding = blockSnapSize;
    const [gridSize, setGridSize] = useState({
      height: 0,
      width: 0,
      originX: 0,
      originY: 0,
    });
    const gridLinesHorizondal = useRef(0);
    const gridLinesVertical = useRef(0);
    const [_vectors, setVectors] = useState({});
    const [freeBodyImage, setFreeBodyImage] = useState(null);
    const [{ iarrowClicked, clickedVectorIndex }, setIarrowClicked] = useState({ iarrowClicked: false, clickedVectorIndex: -1 });
    const [checkBoxClicked, setCheckBoxClicked] = useState(false);
    const [guidChange, setGuidChange] = useState(false);
    const [checkedState, setCheckedState] = useState([]);
    const [questionVectors, setQuestionVectors] = useState([]);
    const [localQuestionVectors, setLocalQuestionVectors] = useState([]);
    const [showVectorHelpText, setShowVectorHelpText] = useState(false);
    const [hasCanvasError, setCanvasHasError] = useState(false);
    const [canvasErrorMessage, setcanvasErrorMessage] = useState("");
    //The canvas starts from top left corner, but graph should be plotted from bottom left corner, so Y axis is different
    const graphXOrigin = useRef(0);
    const graphYOrigin = useRef(0);

    useEffect(() => {
      if (_vectors && _vectors.length !== 0 && checkedState?.length !== _vectors.length) {
        let checkedStateArr = [];
        if (_vectors && Array.isArray(_vectors)) {
          _vectors.forEach(tempVect => {
            let defaultChecked = tempVect.defaultChecked !== null && tempVect.defaultChecked !== undefined && tempVect.defaultChecked !== "" ? tempVect.defaultChecked === "true" : true;
            checkedStateArr.push(defaultChecked)
          })
        }
        setCheckedState(checkedStateArr)
      }
    }, [_vectors])

    //Stage Ref for Style Manipulation
    const canvasStage = useRef(null);

    //selected vector index - the vector that is being dragged or transformed
    const selectedVectorIndex = useRef(-1);
    const isArrowHeadClicked = useRef(false);
    const isDragging = useRef(false);

    //Rule Assignment for Vector Label Position
    const ruleAssignment = (Q, S) => {

      let MapQ = { "Q1": [], "Q2": [], "Q3": [], "Q4": [], "ValueQ1": [], "ValueQ2": [], "ValueQ3": [], "ValueQ4": [], "Rule": [] };
      Q.map((q, index) => {
        if (q === 1) {
          MapQ.Q1.push(index);
          MapQ.ValueQ1.push(q);
        } else if (q === 2) {
          MapQ.Q2.push(index);
          MapQ.ValueQ2.push(q);
        } else if (q === 3) {
          MapQ.Q3.push(index);
          MapQ.ValueQ3.push(q);
        } else {
          MapQ.Q4.push(index);
          MapQ.ValueQ4.push(q);
        }
      });

      let Quadarant = [...Q];
      let Slope = [...S];
      let CountArr = QListCountArray(Quadarant);
      let CheckMorethanTwice = CountArr.some((q) => q > 2);
      let CheckMorethanOnce = CountArr.some((q) => q > 1);
      let rulesArr = multiVectorRule(Quadarant, Slope);
      let ruleArr2 = [];
      let ruleArr3 = [];
      if (CheckMorethanTwice) {
        ruleArr2 = MapQDup(Q, S, MapQ);
        return ruleArr2;
      }
      if (CheckMorethanOnce) {
        ruleArr3 = MapQDup(Q, S, MapQ);
        return ruleArr3;
      }
      return rulesArr;
    }

    function MapQDup(Q, S, MapQ) {
      let { Q1, Q2, Q3, Q4 } = MapQ

      if (Q1.length > 2) {
        MapQ.Rule[Q1[0]] = 3
        MapQ.Rule[Q1[1]] = 3
        MapQ.Rule[Q1[2]] = 3
      } else if (Q1.length > 1) {
        let QPart = [Q[Q1[0]], Q[Q1[1]]]
        let SPart = [S[Q1[0]], S[Q1[1]]]
        let value = ruleTwoLevelComparison(QPart, SPart);
        MapQ.Rule[Q1[0]] = value[0]
        MapQ.Rule[Q1[1]] = value[1]
      } else {
        MapQ.Rule[Q1[0]] = 1
      }
      if (Q2.length > 2) {
        MapQ.Rule[Q2[0]] = 3
        MapQ.Rule[Q2[1]] = 3
        MapQ.Rule[Q2[2]] = 3
      } else if (Q2.length > 1) {
        let QPart = [Q[Q2[0]], Q[Q2[1]]]
        let SPart = [S[Q2[0]], S[Q2[1]]]
        let value = ruleTwoLevelComparison(QPart, SPart);
        MapQ.Rule[Q2[0]] = value[0]
        MapQ.Rule[Q2[1]] = value[1]
      } else {
        MapQ.Rule[Q2[0]] = 1
      }
      if (Q3.length > 2) {
        MapQ.Rule[Q3[0]] = 3
        MapQ.Rule[Q3[1]] = 3
        MapQ.Rule[Q3[2]] = 3
      } else if (Q3.length > 1) {
        let QPart = [Q[Q3[0]], Q[Q3[1]]]
        let SPart = [S[Q3[0]], S[Q3[1]]]
        let value = ruleTwoLevelComparison(QPart, SPart);
        MapQ.Rule[Q3[0]] = value[0]
        MapQ.Rule[Q3[1]] = value[1]
      } else {
        MapQ.Rule[Q3[0]] = 1
      }
      if (Q4.length > 2) {
        MapQ.Rule[Q4[0]] = 3
        MapQ.Rule[Q4[1]] = 3
        MapQ.Rule[Q4[2]] = 3
      } else if (Q4.length > 1) {
        let QPart = [Q[Q4[0]], Q[Q4[1]]]
        let SPart = [S[Q4[0]], S[Q4[1]]]
        let value = ruleTwoLevelComparison(QPart, SPart);
        MapQ.Rule[Q4[0]] = value[0]
        MapQ.Rule[Q4[1]] = value[1]
      } else {
        MapQ.Rule[Q4[0]] = 1
      }
      console.log("LabelR ::: MapQ", MapQ)
      return MapQ.Rule;

    }


    function multiVectorRule(Q, S) {
      let rules = [];
      while (Q.length > 0) {
        let QPart = Q.splice(0, 2);
        let SPart = S.splice(0, 2);
        let value = ruleTwoLevelComparison(QPart, SPart);
        if (value !== undefined) {
          rules.push(...value);
        }
      }
      return rules;
    }

    function ruleTwoLevelComparison(Q, S) {
      let [Q1, Q2] = Q;
      let [S1, S2] = S;
      if (Q1 !== Q2) {
        if ((Q1 === 1 && Q2 === 2) || (Q1 === 3 && Q2 === 4) || (Q1 === 4 && Q2 === 3) || (Q1 === 2 && Q2 === 1)) {
          return [2, 2];
        } else if ((Q1 === 1 && Q2 === 3) || (Q1 === 3 && Q2 === 1) || (Q1 === 1 && Q2 === 4) || (Q1 === 4 && Q2 === 1) || (Q1 === 2 && Q2 === 3) || (Q1 === 3 && Q2 === 2)) {
          return [1, 1];
        } else if ((Q1 === 4 && Q2 === 2) || (Q1 === 2 && Q2 === 4)) {
          return [1, 2];
        } else {
          return [1, 1];
        }
      } else {
        if (Q1 === 1 && Q2 === 1) {
          if (S1 > S2) {
            return [1, 2];
          } else if (S1 < S2) {
            return [2, 1];
          } else {
            return [1, 2];
          }
        } else if (Q1 === 2 && Q2 === 2) {
          if (S1 > S2) {
            return [2, 1];
          } else if (S1 < S2) {
            return [1, 2];
          } else {
            return [2, 1];
          }
        } else if (Q1 === 3 && Q2 === 3) {
          if (S1 > S2) {
            return [1, 2];
          } else if (S1 < S2) {
            return [2, 1];
          } else {
            return [1, 2];
          }
        } else if (Q1 === 4 && Q2 === 4) {
          if (S1 > S2) {
            return [2, 1];
          } else if (S1 < S2) {
            return [1, 2];
          } else {
            return [2, 1];
          }
        } else {
          return [1, 1];
        }

      }
    }


    useEffect(() => {
      const widthStepSized = width;
      const heightStepSized = height;
      const gridWidth = stepSize * (widthStepSized / stepSize);
      const gridHeight = stepSize * (heightStepSized / stepSize);
      gridLinesHorizondal.current = gridHeight / padding;
      gridLinesVertical.current = gridWidth / padding;

      //The canvas starts from top left corner, but graph should be plotted from bottom left corner, so Y axis is different
      graphXOrigin.current = (width - gridWidth) / 2; //Same as Origin of Graph
      graphYOrigin.current =
        (height - gridHeight) / 2 +
        Math.round(gridLinesHorizondal.current * padding); //This will be max height of the graph
      const originY = (height - gridHeight) / 2;
      const originX = (width - gridWidth) / 2;
      setGridSize({
        height: gridHeight,
        width: gridWidth,
        originY: originY,
        originX: originX,
      });

      //Add Free Body Image BG
      if (freeBodyDiagram) {
        const current = new window.Image();
        current.src = freeBodyDiagram;
        current.width = fbdWidth;
        current.height = fbdHeight;

        current.addEventListener('load', () => {
          setFreeBodyImage(current);
        });
      }
    }, [height, width, stepSize, padding, freeBodyDiagram, fbdWidth, fbdHeight]);

    //Used by Parent
    useImperativeHandle(ref, () => ({
      drawVectors({ vectors }) {
        if (height <= 0 || width <= 0) {
          return null;
        }
        const tempVectors = [];
        const tempPromises = [];
        const tempDirection = [];
        console.debug("vectors============", vectors)
        if (vectors.length) {

          vectors.forEach((vector) => {
            if (vectors.length > 1) {
              tempDirection.push(getAngleDeg(vector))
            }
            if (vector.type === "angle-magnitude") {
              tempPromises.push(
                new Promise((resolve) => {
                  const current = new window.Image();
                  if (vector.direction === "in") current.src = inPointVector;
                  else current.src = outPointVector;

                  const magX = stepSize * (vector.mag > 0 ? vector.mag : 0);
                  const magY = stepSize * (vector.angle > 0 ? vector.angle : 0);
                  const vectorLabel = magX === 0 && magY === 0 ? `${vector.name}=0` : vector.name;
                  const latexObject = vector.name ? window.MathJax.tex2svg(vectorLabel) : null;

                  if (latexObject) {
                    const s = new XMLSerializer().serializeToString(
                      latexObject.children[0]
                    );
                    const encodedData = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(s)))}`;
                    const current = new window.Image();
                    current.src = encodedData;
                    current.addEventListener("load", () => {
                      tempVectors.push({
                        ...vector,
                        latexImage: current,
                        magX: magX,
                        magY: magY,
                        ref: createRef(),
                      });
                      resolve();
                    });
                  } else {
                    tempPromises.push(new Promise(resolve => {
                      tempVectors.push({
                        ...vector,
                        latexImage: null,
                        magX: magX,
                        magY: magY,
                        ref: createRef()
                      });
                      resolve();
                    }));
                  }
                })
              );
            } else {
              const magX = stepSize * vector.x;
              const magY = stepSize * vector.y;
              const vectorLabel = magX === 0 && magY === 0 ? `${vector.name}=0` : vector.name;
              const latexObject = vector.name ? window.MathJax.tex2svg(vectorLabel) : null;
              if (latexObject) {
                const s = new XMLSerializer().serializeToString(
                  latexObject.children[0]
                );
                const encodedData = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(s)))}`;
                const current = new window.Image();
                current.src = encodedData;
                tempPromises.push(
                  new Promise((resolve) => {
                    current.addEventListener("load", () => {
                      tempVectors.push({
                        ...vector,
                        latexImage: current,
                        magX: magX,
                        magY: magY,
                        ref: createRef(),
                      });

                      resolve();
                    });
                  })
                );
              } else {
                tempPromises.push(new Promise(resolve => {
                  tempVectors.push({
                    ...vector,
                    latexImage: null,
                    magX: magX,
                    magY: magY,
                    ref: createRef()
                  });
                  resolve();
                }));
              }
            }
          });
        } else {
          const latexObject = window.MathJax.tex2svg("demo copy");
          if (latexObject) {
            const s = new XMLSerializer().serializeToString(
              latexObject.children[0]
            );
            const encodedData = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(s)))}`;
            const current = new window.Image();
            current.src = encodedData;
            tempPromises.push(
              new Promise((resolve) => {
                current.addEventListener("load", () => {
                  resolve();
                });
              })
            )
          }
        }

        Promise.all(tempPromises).then(() => {
          if (tempVectors.length > 1) {
            let CountInsideArr = QListCountArray(tempDirection)
            for (let x = 0; x < tempDirection.length; x++) {
              if (CountInsideArr[x] > 1) {
                let newX = x
                let indexFound = tempDirection.indexOf(tempDirection[x], newX + 1)
                if (indexFound && indexFound !== -1) {
                  if (tempDirection[x] === tempDirection[indexFound]) {
                    tempVectors[x].strokeWidth = 10
                  }
                }
              }
            }
          }
          let Quadarant = [];
          let Slope = [];
          if (tempVectors && tempVectors.length > 0) {
            if (tempVectors.length > 1) {
              tempVectors.map((vec) => {
                Quadarant.push(getQuadrant(vec.x, vec.y, vec.posX, vec.posY, vec.gridWidthUnit, vec.gridHeightUnit));
                Slope.push(getSlope(vec.x, vec.y, vec.posX, vec.posY, vec.gridWidthUnit, vec.gridHeightUnit));
                if (vec.inputType === "angle-magnitude") {
                  console.log(`Point ::: Question Vector "${vec.name}" => magnitude value is "${vec.mag}" and angle value is "${vec.angle}"`);
                  console.log(`Point ::: Question Vector "${vec.name}" => magnitude Origin X is "${vec.x}" and angle Origin Y value is "${vec.y}"`);
                } else {
                  const formatValue = (value) => value.toString();
                  if (vec.autoOrigin) {
                    vec.posX = formatValue(Math.trunc((vec.gridWidthUnit / 2) - (vec.x / 2)));
                    vec.posY = formatValue(Math.trunc((vec.gridHeightUnit / 2) - (vec.y / 2)));
                    console.log(vec.name, " => ", "Auto X-Orgin", vec.posX, "Auto Y-Orgin", vec.posY)
                  }
                  console.log(`Point ::: Question Vector "${vec.name}" => X value is "${vec.x}" and Y value is "${vec.y}"`);
                }
              });
            } else {
              // if(tempVectors[0].inputType === "angle-magnitude") {
              //     console.log(`Point ::: Question Vector "${tempVectors[0].name}" => magnitude value is "${tempVectors[0].mag}" and angle value is "${tempVectors[0].angle}"`);
              //     console.log(`Point ::: Question Vector "${tempVectors[0].name}" => magnitude X pos value is "${tempVectors[0].x}" and angle Y pos value is "${tempVectors[0].y}"`);
              //   } else {
              //     console.log(`Point ::: Question Vector "${tempVectors[0].name}" => X value is "${tempVectors[0].x}" and Y value is "${tempVectors[0].y}"`);
              //   }
            }
          }

          if (tempVectors && tempVectors.length > 0) {
            // console.log("LabelR ::: Quadarant=", Quadarant)
            // console.log("LabelR ::: Slope=", Slope)
            // console.log("commonVectorSettings", commonVectorSettings)
            let Nvector = tempVectors.length;
            if (tempVectors.length == 1) {
              tempVectors[0].Nvector = Nvector
              tempVectors[0].gridHeightUnit = commonVectorSettings.heightUnit
              tempVectors[0].gridWidthUnit = commonVectorSettings.widthUnit
            }
            if (tempVectors.length > 1) {
              let labelRule = ruleAssignment(Quadarant, Slope);
              console.log("LabelR ::: LabelRule=", labelRule)
              tempVectors.map((vec, index) => {
                if (labelRule && labelRule.length > 0) {
                  tempVectors[index].labelRule = labelRule[index];
                }
                tempVectors[index].Nvector = Nvector;
                tempVectors[index].gridHeightUnit = tempVectors[index].gridHeightUnit ? tempVectors[index].gridHeightUnit : commonVectorSettings.heightUnit;
                tempVectors[index].gridWidthUnit = tempVectors[index].gridWidthUnit ? tempVectors[index].gridWidthUnit : commonVectorSettings.widthUnit;
              })
            }
          }
          setVectors(tempVectors);
          if (tempVectors && tempVectors.length && type !== 'answer') {
            if (appContext && appContext.updateQuestionVectorsMapArr && appContext.questionVectorsMapArr[currentQuestionID] === undefined) {
              appContext.updateQuestionVectorsMapArr(currentQuestionID, tempVectors);
            }
          }

          //setCheckedState(new Array(tempVectors.length).fill(true))

        });
      },
    }));

    useEffect(() => {
      if (showQuestionVectorPrompt) {
        if (appContext.questionVectorsMapArr && currentQuestionID) {
          let dataArr = appContext.questionVectorsMapArr[currentQuestionID]
          if (dataArr && dataArr.length && questionVectors.length == 0) {
            setQuestionVectors(dataArr);
            setLocalQuestionVectors(dataArr);
          }
        }
      }
    }, [showQuestionVectorPrompt, appContext.questionVectorsMapArr])
  
    const onVectorMouseDown = (props) => {
      const { index, arrowHeadClicked } = props;
      isArrowHeadClicked.current = arrowHeadClicked;
      selectedVectorIndex.current = index;
    };

    const originHelpText = (vector) => {
      let vectorOrigin = "";
      if (vector.gridHeightUnit !== undefined && vector.gridWidthUnit !== undefined) {
        const isCenter =
          Math.round(vector.gridHeightUnit / 2) === Math.round(vector.gridWidthUnit / 2)
        const originText = isCenter
          ? "center"
          : `(${Math.round(vector.gridWidthUnit / 2)}, ${Math.round(vector.gridHeightUnit / 2)})`;
        vectorOrigin += `${originText}`;
      }
      return vectorOrigin
    }
    const BuildVectorInfo = (vector, index, isSnapToGrid) => {
      let vectorInfo = "";

      /* const vectorName = vector.name?.includes("\\vec")
        ? (vector.name.match(/(?<={).*?(?=})/) || [])[0] || "Unnamed"
        : vector.name || "Unnamed"; */

      let vectorName = vector.name || "";
      if (vectorName.includes("\\vec{")) {
        vectorName = `\\(${vectorName}\\)`
      }

      // Adding the vector name
      if (vector.name) {

        vectorInfo += `The vector, named ${vectorName} `;
      } else {
        vectorInfo += `The vector, `;
      }

      // Adding the vector color
      if (vector.color) {
        vectorInfo += `and colored ${colorsArray.find((e) => e.value === vector.color)?.label || "Unknown"
          }. `;
      }

      function normalizeVector(v) {
        return {
          ...v,
          x: +v.x,
          y: +v.y,
          posX: +v.posX,
          posY: +v.posY,
          magX: +v.magX,
          magY: +v.magY,
        };
      }

      if (vector?.inputType === "components") {

        // Adding vector head location
        if (vector.x !== undefined && vector.y !== undefined) {
          if (isSnapToGrid) {
            vectorInfo += `The head of the vector is at (${Math.round(parseInt(vector.x) + parseInt(vector.posX))}, ${parseInt(vector.y) + parseInt(vector.posY)}) `;
          } else {
            function round1(n) {
              return Math.round(n * 10) / 10;
            }
            let normalizedVector = normalizeVector(vector);
            const headX = round1(normalizedVector.x + normalizedVector.posX);
            const headY = round1(normalizedVector.y + normalizedVector.posY);
            vectorInfo += `The head of the vector is at (${headX}, ${headY})`;
          }


        } else {
          vectorInfo = vectorInfo.trimEnd() + ". ";
        }


        // Adding origin information  
        if (vector.posX !== undefined && vector.posY !== undefined) {
          const isCenter =
            parseInt(vector.posX, 10) === Math.round(vector.gridWidthUnit / 2) &&
            parseInt(vector.posY, 10) === Math.round(vector.gridHeightUnit / 2);

          vectorInfo += `and the tail of the vector is at (${vector.posX}, ${vector.posY}). `;
        }
      } else if (vector?.inputType === "angle-magnitude") {

        // const magnitude = parseFloat(vector.mag); // Magnitude of the vector
        // const headAngle = parseFloat(vector.angle); // Angle of the vector head (in degrees)
        // const angleInRadians = (headAngle * Math.PI) / 180;

        // // If autoOrigin is false, use posX and posY as the tail position
        // const tailX = vector.autoOrigin === false ? parseFloat(vector.posX) || 0 : 0;
        // const tailY = vector.autoOrigin === false ? parseFloat(vector.posY) || 0 : 0;

        // // Compute the head's relative position from the tail
        // const headX = tailX + magnitude * Math.cos(angleInRadians);
        // const headY = tailY + magnitude * Math.sin(angleInRadians);

        // // Derive tail's magnitude and angle if needed (assuming tail is from the origin)
        // const tailMagnitude = Math.sqrt(tailX ** 2 + tailY ** 2);
        // const tailAngle = Math.atan2(tailY, tailX) * (180 / Math.PI); // Convert to degrees
        // console.log("vector2.0-------_>tailX", tailX,tailY,headX,headY);

        // // Construct the description
        // vectorInfo += `The vector starts with its tail at a magnitude of ${tailMagnitude.toFixed(2)} `;
        // vectorInfo += `and an angle of ${tailAngle.toFixed(2)}°. `;
        // vectorInfo += `The head of the vector is at a magnitude of ${magnitude.toFixed(2)} `;
        // vectorInfo += `and an angle of ${headAngle.toFixed(2)}° from the x-axis.`;
        console.log("vector2.0-------_>", vector);

        const magnitude = parseFloat(vector.mag); // Magnitude of the vector
        const angle = parseFloat(vector.angle); // Angle in degrees

        // Check the angle and describe its orientation
        let orientation;
        if (angle === -90) {
          orientation = "-y axis";
        } else if (angle === 90) {
          orientation = "+y axis";
        } else if (angle === 0) {
          orientation = "+x axis";
        } else if (angle === 180 || angle === -180) {
          orientation = "-x axis";
        } else {
          // Normalize angle to [0, 360)
          const normalizedAngle = (angle % 360 + 360) % 360;

          if (normalizedAngle <= 45 || normalizedAngle > 315) {
            // Relative to +x axis
            orientation = `${normalizedAngle.toFixed(2)} degrees from the +x axis`;
          } else if (normalizedAngle > 45 && normalizedAngle <= 135) {
            // Relative to +y axis
            const relativeAngle = normalizedAngle - 90;
            orientation = `${relativeAngle.toFixed(2)} degrees from the +y axis`;
          } else if (normalizedAngle > 135 && normalizedAngle <= 225) {
            // Relative to -x axis
            const relativeAngle = normalizedAngle - 180;
            orientation = `${relativeAngle.toFixed(2)} degrees from the -x axis`;
          } else {
            // Relative to -y axis
            const relativeAngle = normalizedAngle - 270;
            orientation = `${relativeAngle.toFixed(2)} degrees from the -y axis`;
          }
        }

        // Final description
        vectorInfo += `The vector has a magnitude of ${magnitude.toFixed(2)} and an angle of ${orientation}.`;

      }

      //Draw vector
      if (!vector?.inputType) {
        // Adding vector head location
        if (vector.x !== undefined && vector.y !== undefined) {
          vectorInfo += `The head of the vector is at (${Math.round(parseInt(vector.x) + parseInt(vector.posX))}, ${parseInt(vector.y) + parseInt(vector.posY)}) `;
        } else {
          vectorInfo = vectorInfo.trimEnd() + ". ";
        }


        // Adding origin information  
        if (vector.posX !== undefined && vector.posY !== undefined) {
          const isCenter =
            parseInt(vector.posX, 10) === Math.round(vector.gridWidthUnit / 2) &&
            parseInt(vector.posY, 10) === Math.round(vector.gridHeightUnit / 2);

          vectorInfo += `and the tail of the vector is at (${vector.posX}, ${vector.posY}). `;
        }
      }

      if (vector.latexSymbol === SymbolType.OUT_ODOT) {
        vectorInfo = `The vector named ${vectorName} and is pointing out of the page, it is located at (${vector.posX}, ${vector.posY}).`
      }
      if (vector.latexSymbol === SymbolType.IN_OTIMES) {
        vectorInfo = `The vector named ${vectorName} and is pointing in to the page, it is located at (${vector.posX}, ${vector.posY}).`
      }
      if (vector.latexSymbol === SymbolType.SOLID_DOT) {
        let color = colorsArray.find((e) => e.value === vector.color)?.label || vector.color
        vectorInfo = `There is a solid dot with name ${vectorName},  colored ${color}, and located at (${vector.posX}, ${vector.posY}).`
      }

      return vectorInfo.trim();
    };
    const onVectorMouseUp = (props) => {
      if (isDragging.current) return;
      isArrowHeadClicked.current = false;
      const index = selectedVectorIndex.current;
      if (!readOnly) onVectorMoved({ ..._vectors[index], index: index });
    };

    const roundAngles = (props) => {
      const { evt } = props;
      const index = selectedVectorIndex.current;
      let offsetX = 0;
      let offsetY = 0;
      const { type } = evt;

      if (type === 'touchmove') {
        const [touchOffsetX, touchOffsetY] = getOffSetValueFromTouchEvent(evt);
        offsetX = touchOffsetX;
        offsetY = touchOffsetY;
      } else {
        offsetX = evt.offsetX;
        offsetY = evt.offsetY;
      }
      if (isArrowHeadClicked.current === true && index > -1) {
        const currentVector = { ..._vectors[index] };
        const magY = (currentVector.posY - offsetY) / stepSize;
        const magX = (offsetX - currentVector.posX) / stepSize;
        const angle = (Math.atan2(magY, magX) * 180) / Math.PI;
        const roundedAngle = Math.round(angle / degStepSize) * degStepSize;

        const magnitude = Math.sqrt(Math.pow(magY, 2) + Math.pow(magX, 2));
        const roundedMagnitude =
          Math.round(magnitude / magStepSize) * magStepSize;

        currentVector.x =
          roundedMagnitude * Math.cos((roundedAngle * Math.PI) / 180);
        currentVector.y =
          roundedMagnitude * Math.sin((roundedAngle * Math.PI) / 180);
        currentVector.magY = currentVector.y * stepSize;
        currentVector.magX = currentVector.x * stepSize;
        const tempVector = { ...currentVector };
        setVectors(
          _vectors.map((el, elIndex) => {
            if (index === elIndex) return Object.assign({}, currentVector);
            return el;
          })
        );
        setCheckedState(new Array(_vectors.length).fill(true))
        canvasStage.current.draw();
        if (!readOnly) onVectorMoved({ ...tempVector, index: index });
      }
    };

    const roundPoints = (props) => {

      const { evt } = props;
      const index = selectedVectorIndex.current;
      const { height } = gridSize;
      let offsetX = 0;
      let offsetY = 0;
      const { type } = evt;

      if (type === 'touchmove') {
        const [touchOffsetX, touchOffsetY] = getOffSetValueFromTouchEvent(evt);
        offsetX = touchOffsetX;
        offsetY = touchOffsetY;
      } else {
        offsetX = evt.offsetX;
        offsetY = evt.offsetY;
      }

      if (isArrowHeadClicked.current === true && index > -1) {
        const currentVector = { ..._vectors[index] };
        currentVector.x = Math.round(offsetX / stepSize) - currentVector.posX; //snap to nearest grid line
        currentVector.y = (height / stepSize - (Math.round(offsetY / stepSize))) - currentVector.posY; //snap to nearest grid line

        if (currentVector.y === 0 && currentVector.x === 0) {
          currentVector.y = 1;
        }

        const tempVector = { ...currentVector };
        setVectors(
          _vectors.map((el, elIndex) => {
            if (index === elIndex) return Object.assign({}, currentVector);
            return el;
          })
        );
        setCheckedState(new Array(_vectors.length).fill(true))
        canvasStage.current.draw();
        if (!readOnly) onVectorMoved({ ...tempVector, index: index });
      }
    };

    const onVectorMouseMove = (props) => {
      if (stepDeg) {
        roundAngles(props);
      } else {
        roundPoints(props);
      }
    };

    const onDragEnd = (props) => {
      console.log("movingvectord", props)
      const { x, y } = props;

      const index = selectedVectorIndex.current;
      const { originX, originY, height } = gridSize;
      const currentVector = { ..._vectors[index] };
      currentVector.posY =
        (height - Math.round((y - originY) / blockSnapSize) * blockSnapSize) /
        stepSize; //snap to nearest grid line
      currentVector.posX =
        (originX + Math.round((x - originX) / blockSnapSize) * blockSnapSize) /
        stepSize; //snap to nearest grid line

      // setVectors(_vectors.map((el,elIndex) => {
      //     if(index ===elIndex )
      //        return Object.assign({}, currentVector)
      //     return el
      // }));
      if (!readOnly) onVectorMoved({ ...currentVector, index: index });
      isDragging.current = false;
    };

    const onArrowClicked = (props) => {
      const { arrowClicked, index } = props;
      if (arrowClicked) {
        setIarrowClicked({ iarrowClicked: true, clickedVectorIndex: index });
      } else {
        setIarrowClicked({ iarrowClicked: false, clickedVectorIndex: -1 });
      }
      //console.log("Vector Clicked!", arrowClicked, index)
    };

    const onVectorClicked = (props) => {
      //        const {arrowHeadClicked,evnt,index} = props;
    };

    const onDragStart = () => {
      isDragging.current = true;
    };

    const onMouseLeave = () => {
      if (canvasStage && canvasStage.current)
        canvasStage.current.container().style.cursor = "default";
    };

    const OnGridClick = () => {
      if (iarrowClicked) {
        setIarrowClicked({ iarrowClicked: false, clickedVectorIndex: -1 });
      }
    }

    const onVectorCheckBoxClick = (position) => {
      setGuidChange(!guidChange)
      const updatedCheckedState = checkedState.map((item, index) => {
        return index === position ? !item : item
      });
      setCheckBoxClicked(true);
      // if(updatedCheckedState.some((x)=> x===true)){
      //   setCheckBoxClicked(true);
      // }else{
      //   setCheckBoxClicked(false);
      // }
      console.debug("updatedCheckedState", updatedCheckedState, position)
      setCheckedState(updatedCheckedState)
    }

    const getQuestionVectors = (reset) => {
      /* let qvString = window.localStorage.getItem('questionVectors')
      if (qvString) {
        console.debug("Question vector called>>??")
        let qvData = JSON.parse(qvString);
        if (qvData && qvData.length) {
          if ((questionVectors && questionVectors.length === 0) || reset === true) {
            setQuestionVectors(qvData)
          }
        }
      } */
    }

    const handleCanvasError = (error) => {
      setCanvasHasError(true); // Set error state if canvas fails
      setcanvasErrorMessage(error)
    };

    const calcAngleDegrees = (x, y) => {
      return (Math.atan2(y, x) * 180) / Math.PI;
    };

    const calculateMagnitude = (x, y) => {
      return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    };

    const isTrue = (v) => v === true
    return (
      <div style={{
        width: 'fit-content',
        justifyContent: answerType === undefined ? "center" : "flex-start",
        flexDirection: "row",
        alignItems: "center",
        display: "flex",
        flexWrap: "wrap",
      }} className="sf-ques-draw-vector-container d-flex w-100 ">
        <div>
          <div
            className={showAnswerResponse ? (answerCorrect ? "sf-ans-btn-correct py-2" : "sf-ans-btn-incorrect px-3 pt-3 pb-2") : 'bg-white px-3 pt-3 pb-0'} style={{ borderRadius: '10px', minWidth: "200px" }}>

            {/* View Vector checkbox */}
            {/* {_vectors && _vectors.length > 0 && type !== 'answer' ?
              <div style={{
                width: "100%",
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }} className="view-vectors-container">
                <div style={{ display: "flex", marginTop: '0px', borderRadius: '10px' }} className="mb-2 w-100">
                  <VectorCheckbox
                    _vectors={_vectors}
                    onArrowClicked={onVectorCheckBoxClick}
                    checkedState={checkedState}
                  />
                </div>
              </div>
              : null} */}


            {/* Answer only: Show Reset question vector  */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}>
              {type === "answer" ?
                <div className="d-flex justify-content-end align-items-center w-100">
                  <Tooltip title={<Typography className='text-white' fontSize={14}>Reset question vector</Typography>} placement="top" arrow>
                    <IconButton onClick={() => {
                      setLocalQuestionVectors(questionVectors);
                    }}
                      disabled={!showQuestionVectorPrompt}
                      style={{
                        opacity: showQuestionVectorPrompt ? 1 : 0,
                      }}
                    >
                      <MdRefresh color="#bb0000" />
                    </IconButton>
                  </Tooltip>
                </div>
                : null}


              {hasCanvasError ? (
                <div style={{ padding: "20px", backgroundColor: "#f8d7da", color: "#842029", border: "1px solid #f5c2c7", borderRadius: "5px" }}>
                  <h3>Something went wrong.</h3>
                  <p>
                    The vector could not be displayed.
                    <p>Please download the zip file and email it to <u>support@stemfluency.org</u> </p>
                    <button onClick={() => {
                      downloadErrorInfo(canvasErrorMessage)
                    }}>Download error logs</button>

                    <br />
                    <br />
                    Please use the vector help text below for more information:
                    <br />
                    {_vectors?.length > 0 ? (
                      <>
                        <div>
                          The vector(s) are placed on a grid with dimensions (
                          {_vectors[0].gridWidthUnit}/{_vectors[0].gridHeightUnit}).
                          The origin of the grid is located at {originHelpText(_vectors[0])}.
                          A total of {_vectors?.length} vector(s) are present, listed as follows:
                        </div>
                        <ol style={{ margin: "0", paddingLeft: "20px" }}>
                          {_vectors.map((vector, index) => {
                            let helpText = BuildVectorInfo(vector, index, isSnapToGrid);
                            return (
                              <li key={index} style={{ marginTop: "5px" }}>
                                {/* {BuildVectorInfo(vector, index)} */}
                                <MathJaxPreview math={helpText} />
                              </li>
                            )
                          })}
                        </ol>
                      </>
                    ) : (
                      "No vector information is available."
                    )}
                  </p>
                </div>
              ) :
                <Stage
                  // width={width + (type === "answer" && answerType === undefined ? 120 : 0)}
                  // height={height + (type === "answer" && answerType === undefined ? 120 : 0)}
                  // offsetX={type === "answer" && answerType === undefined ? -60 : 0}
                  // offsetY={type === "answer" && answerType === undefined ? -60 : 0}
                  width={width + PADDING * 2}
                  height={height + PADDING * 2}
                  offsetX={-PADDING}
                  offsetY={-PADDING}

                  ref={canvasStage}
                  onError={handleCanvasError}
                // onTouchMove={onVectorMouseMove}
                // onTouchEnd={onVectorMouseUp}
                // onMouseLeave={onMouseLeave}
                // onMouseMove={onVectorMouseMove}
                // onMouseUp={onVectorMouseUp}
                >
                  <Layer>
                    <Rect
                      x={0}
                      y={0}
                      width={width}
                      height={height}
                      stroke={gridLinesColors[gridColor]}
                      strokeWidth={4}
                      lineJoin="round"
                      visible={enableBorder !== undefined || enableBorder !== null ? enableBorder : true}
                      //opacity={iarrowClicked || checkBoxClicked? 0.2:1}
                      onClick={OnGridClick}
                    />
                  </Layer>

                  <Layer>
                    {enableGrid === false ? null : (
                      <Grid
                        gridSize={gridSize}
                        gridLinesHorizondal={gridLinesHorizondal}
                        enableDarkGridLine={enableDarkGridLine}
                        gridLinesVertical={gridLinesVertical}
                        padding={padding}
                        gridLinesColor={gridLinesColors[gridColor]}
                        GridClick={OnGridClick}
                        gridColor={gridColor}
                      //opacity={iarrowClicked || checkBoxClicked? 0.2:1}

                      />
                    )}
                  </Layer>

                  {(freeBodyImage && freeBodyImage != null) && (freeBodyDiagram && freeBodyDiagram != null) && !isAnswer ? (
                    <Layer>
                      <Image
                        image={freeBodyImage}
                        x={fbdX * stepSize}
                        y={fbdY * stepSize}
                      //opacity={iarrowClicked || checkBoxClicked? 0.2:1}
                      // onClick={OnGridClick}
                      />
                    </Layer>
                  ) : null}

                  {commonVectorSettings && commonVectorSettings.image && commonVectorSettings.showImageInAnswers && isAnswer ?
                    <Layer>
                      <Image
                        image={freeBodyImage}
                        x={fbdX * stepSize}
                        y={fbdY * stepSize}
                      // opacity={iarrowClicked || checkBoxClicked? 0.2:1}
                      // onClick={OnGridClick}
                      />
                    </Layer>
                    : null}

                  {enableRuler === false ? null : (
                    <RulerLayer
                      graphXOrigin={graphXOrigin}
                      graphYOrigin={graphYOrigin}
                      rulerXPoint={rulerXPoint}
                      rulerYPoint={rulerYPoint}
                      stepSize={stepSize}
                      gridSize={gridSize}
                      gridLinesHorizondal={gridLinesHorizondal}
                      gridLinesVertical={gridLinesVertical}
                      width={width}
                      height={height}
                      rulerXLabel={rulerXLabel}
                      rulerYLabel={rulerYLabel}
                      rulerNXLabel={rulerNXLabel}
                      rulerNYLabel={rulerNYLabel}
                      GridClick={OnGridClick}
                      showScale={showScale}
                      scale={scale}
                    //opacity={iarrowClicked || checkBoxClicked? 0.2:1}

                    />
                  )}

                  {/* This is for showing the question vector in answer canvas */}
                  {showQuestionVectorPrompt && localQuestionVectors && localQuestionVectors.length ?
                    localQuestionVectors.map((vect, index) => {

                      let dimension = { width: vect.magY, height: vect.magX }
                      const angle = (Math.atan2(dimension.width, dimension.height) * 180) / Math.PI;
                      let originX = parseFloat(vect.posX ? vect.posX : 0);
                      let originY = parseFloat(vect.posY ? vect.posY : 0);
                      let isSelectForZeroVector = (vect.x == 0 && vect.y == 0) || vect.latexSymbol !== SymbolType.IN_PLANE;

                      // Direct calculation without trigonometry
                      let x1 = originX * stepSize;
                      let y1 = gridSize.height - (originY * stepSize);
                      let ox2 = x1 + (vect.x * stepSize);
                      let oy2 = y1 - (vect.y * stepSize);

                      let p = [
                        x1, y1,
                        ox2, oy2,
                      ]

                      let visible = false;

                      let showAngle = vect.showAngle;
                      let showComponents = vect.showComponents;
                      let showLabel = vect.showLabel;
                      let name = vecName;
                      let color = vect.color;
                      let snapToGrid = isSnapToGrid;
                      let vectorType = "component";
                      if (vectorAnswerFormulas && vectorAnswerFormulas.length) {

                        vectorAnswerFormulas.forEach(vaf => {
                          if (vaf.name === vect.name) {
                            showAngle = vaf.showAngle;
                            showComponents = vaf.showComponents;
                            showLabel = vaf.showLabel;
                            name = vaf.name;
                            color = vaf.formulaColor;
                            vectorType = vaf.formulaType;
                          }
                        })
                      }

                      if (vectorType === "angle-magnitude") {
                        snapToGrid = false;
                      }

                      if (checkedState && checkedState.length && checkedState[index]) {
                        visible = checkedState[index];
                      }

                      console.debug("vect>>>", vect, checkedState, index, visible)

                      let vecName = "";
                      if (vect.name.includes("\\vec")) {
                        vecName = (vect.name.match(/(?<={).*?(?=})/) || [])[0] || ""
                      } else {
                        vecName = vect.name;
                      }
                      if (isSelectForZeroVector) {
                        vecName += " = 0";
                        p = [originX * stepSize,
                        gridSize.height - (originY * stepSize),
                        originX * stepSize,
                        gridSize.height - (originY * stepSize)];
                      }
                      const snapValue = (val, snapBy) => {
                        return Math.round(val / snapBy) * snapBy;
                      }
                      // p = p.map(val => snapValue(val, stepSize));
                      // console.debug("vect====", vect, p, stepSize)

                      let angleOffset = vect.angleOptions?.angleOffset ? vect.angleOptions?.angleOffset : 0;
                      let angleType = vect.angleOptions?.type ? vect.angleOptions?.type : 0
                      // p = [0, 0, 0, 0];
                      p = p.map(ele => {
                        if (isNaN(ele)) {
                          return 0;
                        }
                        return ele;
                      })

                      let latexSymbol = 0;
                      let latexSymbolSize = 0;
                      let labelPositionVec = null;
                      if (vect.labelPositionType === "Manual") {
                        labelPositionVec = {
                          x: vect.labelPositionX ? parseFloat(vect.labelPositionX) : originX,
                          y: vect.labelPositionY ? parseFloat(vect.labelPositionY) : originY,
                        }
                        labelPositionVec.x = labelPositionVec.x * stepSize;
                        labelPositionVec.y = gridSize.height - (labelPositionVec.y * stepSize);
                      }

                      if (vect) {
                        latexSymbol = (vect.latexSymbol !== null && vect.latexSymbol !== undefined) ? vect.latexSymbol : SymbolType.IN_PLANE;
                        latexSymbolSize = vect.latexSymbolSize ? vect.latexSymbolSize : DEFAULT_LATEX_SYMBOL_SIZE;
                      }

                      return (
                        <SFVectorClass
                          vector={vect}
                          vectorType={vectorType}
                          visible={true}
                          plane={vect?.plane}
                          isSelectForZeroVector={isSelectForZeroVector}
                          readOnly={vect?.isStaticVector ? true : readOnly}
                          key={vect.name}
                          index={index}
                          cellSize={stepSize}
                          debug={false}
                          active={true}
                          showAngle={showAngle !== undefined ? showAngle : false}
                          showComponents={showComponents !== undefined ? showComponents : false}
                          showComponents2={false}
                          showValues={false}
                          strokeColor={'grey'}
                          angleOffset={angleOffset}
                          angleType={angleType}
                          // strokeColor={"#bb0000"}
                          strokeWidth={5}
                          gridWidth={gridSize.width}
                          gridHeight={gridSize.height}
                          gridValue={stepSize}
                          minGridValue={stepSize + (stepSize * 0.707)}
                          // points={[190, 190, 298, 326]}
                          points={p}
                          degree={angle}
                          length={5}
                          // snap={isAngleOrMagnitudeTextFieldChanged ? false : true}
                          // snapOnDrag={true}
                          snapToGrid={snapToGrid}
                          clamp={true}
                          disableArrowDrag={true}
                          updatePoints={(newPoints, isByDragging) => {
                            let updatedVect = { ...vect };

                            let vecA = new Victor(newPoints[0], newPoints[1]).divideScalar(stepSize);
                            let vecB = new Victor(newPoints[2], newPoints[3]).divideScalar(stepSize);

                            let diff = {
                              x: 0,
                              y: 0,
                            };

                            diff = {
                              x: vecB.x - vecA.x,
                              y: vecA.y - vecB.y,
                            };

                            if (!isSelectForZeroVector) {
                              updatedVect.posX = newPoints[0] / stepSize;
                              updatedVect.posY = (gridSize.height - newPoints[1]) / stepSize;
                              updatedVect.x = diff.x;
                              updatedVect.y = diff.y;
                            } else {
                              updatedVect.posX = newPoints[0] / stepSize;
                              updatedVect.posY = (newPoints[1]) / stepSize;
                              updatedVect.x = 0;
                              updatedVect.y = 0;
                            }

                            // console.debug("updateVector points -----", isSelectForZeroVector, newPoints, updatedVect, vecA, vecB, diff, "gridSize.height=", gridSize.height, "vect>>>>" , vect);

                            handleAngleMagnitudeTextFieldChange(false);

                            let tempQuestionVectorsArr = [...localQuestionVectors];
                            tempQuestionVectorsArr[index] = updatedVect;
                            setLocalQuestionVectors(tempQuestionVectorsArr);
                            // onVectorMoved({ ...updatedVect, index: index });

                          }}
                          updateActive={() => { }}
                          updateVectorLength={(index, length) => {
                            // console.debug("updateVector length",index, length)
                          }}
                          updateVectornAngle={(index, angle) => {
                            // console.debug("updateVector angle",index, angle)
                          }}
                          updateVectorXComponentLength={() => { }}
                          updateVectorYComponentLength={() => { }}
                          text={vect.name}
                          showLabel={showLabel !== undefined ? showLabel : false}
                          zeroVectorPointRadius={vect?.zeroVectorPointRadius ? vect?.zeroVectorPointRadius : DEFAULT_ZERO_POINT_RADIUS}
                          zeroVectorPointColor={"grey"}
                          labelPositionVec={labelPositionVec}
                          labelPositionType={vect.labelPositionType ? vect.labelPositionType : "Automatic"}
                          latexSymbol={latexSymbol}
                          latexSymbolSize={latexSymbolSize ? latexSymbolSize : DEFAULT_LATEX_SYMBOL_SIZE}
                        />
                      );
                    }) :
                    null}

                  {_vectors && _vectors.length ? _vectors.map((vect, index) => {
                    console.debug("atype>>>>> answerVectors", type, _vectors)
                    /*  let dimension = { width: vect.magY, height: vect.magX }
                      const angle = (Math.atan2(dimension.width, dimension.height) * 180) / Math.PI;
                      const magnitude = Math.sqrt(
                        Math.pow(dimension.width, 2) + Math.pow(dimension.height, 2)
                      );
                      const reducedMagnitude =
                        magnitude - Math.sqrt(2 * Math.pow(vect.strokeWidth - 1, 2));
                      const x2 = Math.sin((angle * Math.PI) / 180) * reducedMagnitude;
                      const y2 = Math.cos((angle * Math.PI) / 180) * reducedMagnitude;
                      // 4 - is the origin, 24 is grid value
                      let originX = parseInt(vect.posX ? vect.posX : 0, 10);
                      let originY = parseInt(vect.posY ? vect.posY : 0, 10);

                      let isSelectForZeroVector = vect.x === 0 && vect.y === 0;

                      // WORKING
                      let x1 = originX * stepSize;
                      let y1 = gridSize.height - (originY * stepSize);
                      let ox2 = x1 + y2
                      let oy2 = (gridSize.height - (originY * stepSize)) - x2 */

                    let dimension = { width: vect.magY, height: vect.magX }
                    let angle = (Math.atan2(dimension.width, dimension.height) * 180) / Math.PI;
                    let originX = parseFloat(vect.posX ? vect.posX : 0);
                    let originY = parseFloat(vect.posY ? vect.posY : 0);
                    let isSelectForZeroVector = vect.x === 0 && vect.y === 0;

                    // Direct calculation without trigonometry
                    let x1 = originX * stepSize;
                    let y1 = gridSize.height - (originY * stepSize);
                    let ox2 = x1 + (vect.x * stepSize);
                    let oy2 = y1 - (vect.y * stepSize);

                    let p = [
                      x1, y1,
                      ox2, oy2,
                    ]

                    let showAngle = vect.showAngle;
                    let showComponents = vect.showComponents;
                    let showLabel = vect.showLabel;
                    let name = vecName;
                    let color = vect.color;
                    let snapToGrid = isSnapToGrid;
                    let vectorType = "component";

                    let latexSymbol = 0;
                    let latexSymbolSize = 0;

                    let labelPositionVec = null;
                    let labelPositionType = null;
                    if (vectorAnswerFormulas && vectorAnswerFormulas.length) {
                      vectorAnswerFormulas.forEach(vaf => {
                        if (vaf.name === vect.name) {
                          showAngle = vaf.showAngle;
                          showComponents = vaf.showComponents;
                          showLabel = vaf.showLabel;
                          name = vaf.name;
                          color = vaf.formulaColor;
                          vectorType = vaf.formulaType;
                          if (vaf.formulaType === "angle-magnitude") {
                            snapToGrid = false;
                          }
                          if (vaf.labelPositionType) {
                            labelPositionType = vaf.labelPositionType;
                          }
                          if (vect && vaf.labelPositionType === "Manual") {
                            labelPositionVec = {
                              x: vaf.labelPositionX ? parseFloat(vaf.labelPositionX) : 1,
                              y: vaf.labelPositionY ? parseFloat(vaf.labelPositionY) : 1,
                            }
                            labelPositionVec.x = labelPositionVec.x * stepSize;
                            labelPositionVec.y = gridSize.height - (labelPositionVec.y * stepSize);
                          }
                        }
                      })
                    }

                    if (!isAnswer) {
                      console.debug("vectorType>>??", vectorType, vect)
                      if (vect && vect.inputType) {
                        vectorType = vect.inputType;
                      }
                    }
                    if (vectorType === "angle-magnitude") {
                      snapToGrid = false;
                      angle = vect.angle;
                    }

                    let visible = false;

                    if (checkedState && checkedState.length && checkedState[index]) {
                      visible = checkedState[index];
                    }

                    let vecName = "";
                    if (vect.name.includes("\\vec")) {
                      vecName = (vect.name.match(/(?<={).*?(?=})/) || [])[0] || ""
                    } else {
                      vecName = vect.name;
                    }
                    if (isSelectForZeroVector) {
                      vecName += " = 0";
                      p = [originX * stepSize,
                      gridSize.height - (originY * stepSize),
                      originX * stepSize,
                      gridSize.height - (originY * stepSize)];
                    }
                    const snapValue = (val, snapBy) => {
                      return Math.round(val / snapBy) * snapBy;
                    }
                    // p = p.map(val => snapValue(val, stepSize));
                    // console.debug("vect====", vect, p, stepSize)



                    let angleOffset = vect.angleOptions?.angleOffset ? vect.angleOptions?.angleOffset : 0;
                    let angleType = vect.angleOptions?.type ? vect.angleOptions?.type : 0
                    // p = [0, 0, 0, 0];
                    p = p.map(ele => {
                      if (isNaN(ele)) {
                        return 0;
                      }
                      return ele;
                    })
                    console.debug("snapToGrid>>??--", snapToGrid)

                    if (vect.labelPositionType) {
                      labelPositionType = vect.labelPositionType;
                    }

                    if (vect.labelPositionType === "Manual") {
                      labelPositionVec = {
                        x: vect.labelPositionX ? parseFloat(vect.labelPositionX) : originX,
                        y: vect.labelPositionY ? parseFloat(vect.labelPositionY) : originY,
                      }
                      labelPositionVec.x = labelPositionVec.x * stepSize;
                      labelPositionVec.y = gridSize.height - (labelPositionVec.y * stepSize);
                    }

                    if (vectorAnswerFormula && vectorAnswerFormula.labelPositionType) {
                      labelPositionType = vectorAnswerFormula.labelPositionType;
                      if (labelPositionType === "Manual") {
                        labelPositionVec = {
                          x: vectorAnswerFormula.labelPositionX ? parseFloat(vectorAnswerFormula.labelPositionX) : originX,
                          y: vectorAnswerFormula.labelPositionY ? parseFloat(vectorAnswerFormula.labelPositionY) : originY,
                        }
                        labelPositionVec.x = labelPositionVec.x * stepSize;
                        labelPositionVec.y = gridSize.height - (labelPositionVec.y * stepSize);
                      }
                    }

                    if (vect) {
                      latexSymbol = (vect.latexSymbol !== null && vect.latexSymbol !== undefined) ? vect.latexSymbol : SymbolType.IN_PLANE;
                      latexSymbolSize = vect.latexSymbolSize ? vect.latexSymbolSize : DEFAULT_LATEX_SYMBOL_SIZE;
                    }

                    // always use the vector color
                    let zeroVectorPointColor = vect.color;
                  
                    return (
                      <SFVectorClass
                        vector={vect}
                        vectorType={vectorType}
                        visible={visible}
                        plane={vect?.plane}
                        isSelectForZeroVector={isSelectForZeroVector}
                        readOnly={vect?.isStaticVector ? true : readOnly}
                        key={vect.name}
                        index={index}
                        cellSize={stepSize}
                        debug={false}
                        active={true}
                        showAngle={showAngle !== undefined ? showAngle : false}
                        showComponents={showComponents !== undefined ? showComponents : false}
                        showComponents2={false}
                        showValues={false}
                        strokeColor={color}
                        angleOffset={angleOffset}
                        angleType={angleType}
                        // strokeColor={"#bb0000"}
                        strokeWidth={5}
                        gridWidth={gridSize.width}
                        gridHeight={gridSize.height}
                        gridValue={stepSize}
                        minGridValue={stepSize + (stepSize * 0.707)}
                        // points={[190, 190, 298, 326]}
                        points={p}
                        degree={angle}
                        length={5}
                        // snap={isAngleOrMagnitudeTextFieldChanged ? false : true}
                        // snapOnDrag={true}
                        // snapToGrid={isAnswer ? snapToGrid : true}
                        snapToGrid={snapToGrid}
                        clamp={true}
                        disableArrowDrag={false}
                        updatePoints={(newPoints, isByDragging) => {
                          let updatedVect = { ...vect };

                          let vecA = new Victor(newPoints[0], newPoints[1]).divideScalar(stepSize);
                          let vecB = new Victor(newPoints[2], newPoints[3]).divideScalar(stepSize);

                          let diff = {
                            x: 0,
                            y: 0,
                          };

                          diff = {
                            x: vecB.x - vecA.x,
                            y: vecA.y - vecB.y,
                          };

                          if (!isSelectForZeroVector) {
                            updatedVect.posX = newPoints[0] / stepSize;
                            updatedVect.posY = (gridSize.height - newPoints[1]) / stepSize;
                            updatedVect.x = diff.x;
                            updatedVect.y = diff.y;
                          } else {
                            updatedVect.posX = newPoints[0] / stepSize;
                            updatedVect.posY = (newPoints[1]) / stepSize;
                            updatedVect.x = 0;
                            updatedVect.y = 0;
                          }

                          // console.debug("updateVector points -----", isSelectForZeroVector, newPoints, updatedVect, vecA, vecB, diff, "gridSize.height=", gridSize.height, "vect>>>>" , vect);

                          handleAngleMagnitudeTextFieldChange(false);

                          onVectorMoved({ ...updatedVect, index: index });

                        }}
                        updateActive={() => { }}
                        updateVectorLength={(index, length) => {
                          // console.debug("updateVector length",index, length)
                        }}
                        updateVectornAngle={(index, angle) => {
                          // console.debug("updateVector angle",index, angle)
                        }}
                        updateVectorXComponentLength={() => { }}
                        updateVectorYComponentLength={() => { }}
                        text={vect.name}
                        showLabel={showLabel !== undefined ? showLabel : false}
                        zeroVectorPointRadius={vect?.zeroVectorPointRadius ? vect?.zeroVectorPointRadius : DEFAULT_ZERO_POINT_RADIUS}
                        zeroVectorPointColor={zeroVectorPointColor}
                        labelPositionVec={labelPositionVec}
                        labelPositionType={labelPositionType ? labelPositionType : "Automatic"}
                        latexSymbol={latexSymbol}
                        latexSymbolSize={latexSymbolSize ? latexSymbolSize : DEFAULT_LATEX_SYMBOL_SIZE}
                      />
                    );
                  }) : null}
                </Stage>
              }
            </div>
            <div className="vectorHelptextCanvasContainer">
              <VectorHelpText _vectors={_vectors} originHelpText={originHelpText} BuildVectorInfo={BuildVectorInfo} isSnapToGrid={isSnapToGrid} />
            </div>
          </div>

        </div>
        <div>
          {type !== "answer"  ?
            <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginBottom: "6px" }}>
              {_vectors && _vectors.length ? _vectors.map((vector, index) => {

                  let x = vector.x;
                  let y = vector.y;
                  let angle = calcAngleDegrees(vector.x, vector.y);
                  let mag = calculateMagnitude(vector.x, vector.y);
                  if (vector.latexSymbol !== SymbolType.IN_PLANE) {
                    x = 0;
                    y = 0;
                    angle = 0;
                    mag = 0;
                  }

                  let checked = checkedState[index] !== undefined ? checkedState[index] : true;
                  let showLegend = (vector.showLegend !== null && vector.showLegend !== undefined) ? vector.showLegend : true;
                  if (!showLegend) return;

                return (
                  <div style={{ border: "1px solid #ddd", background: "#fff", padding: "10px", borderRadius: "6px" }}>
                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                        {vector.latexSymbol === SymbolType.IN_PLANE ? 
                            <ReactSVG
                              src={arrowSVG}
                              alt="a"
                              style={{ fill: vector.color }}
                              beforeInjection={(svg) => {
                                svg.classList.add("arrow-svg");
                                svg.setAttribute(
                                  "style",
                                  `fill: ${vector.color}`
                                );
                              }}
                            />
                          : null}
                          {vector.latexSymbol === SymbolType.SOLID_DOT ? 
                            <div style={{display:"flex", justifyContent:"center", alignItems:"center", }}>
                              <FaCircle color={vector.color} fontSize={18} />
                            </div>
                          : null}
                          {vector.latexSymbol === SymbolType.IN_OTIMES ? 
                            <div style={{display:"flex", justifyContent:"center", alignItems:"center", }}>
                              <img src={oTimesImg} alt="in times image" className="vector-legend-img" />
                            </div>
                          : null}
                          {vector.latexSymbol === SymbolType.OUT_ODOT ? 
                            <div style={{display:"flex", justifyContent:"center", alignItems:"center", }}>
                              <img src={oDotImg} alt="out dot image" className="vector-legend-img" />
                            </div>
                          : null}
                           <FormControlLabel
                                className="p-0 m-0"
                                onChange={(event) => {
                                    onVectorCheckBoxClick(index)
                                }}
                                checked={checked}
                                control={
                                  <Checkbox
                                    size="small"
                                    icon={
                                        <MdCheckBoxOutlineBlank
                                        style={{
                                            fontSize: 18,
                                            color: vector.color,   // border color
                                        }}
                                        />
                                    }
                                    checkedIcon={
                                        <MdCheckBox
                                        style={{
                                            fontSize: 18,
                                            color: vector.color,   // fill color when checked
                                        }}
                                        />
                                    }/>
                                }
                                label={
                                    // <MathJax math={_vector && _vector.name ? String.raw`$${_vector.name}$` : ''} />
                                    <MathJaxPreview math={`\\(${vector.name}\\)`} />
                                }
                            />
                        </div>
                    {questionShowComponents ?
                      <div>
                        <div className='sf-vector-setting'>
                          <label htmlFor='x'>
                            <MathJaxPreview math={String.raw`$x$`} />
                          </label>
                          <SFVectorInput
                            value={x}
                            disabled={true}
                            onUpdate={newVal => { }}
                            precision={isSnapToGrid ? 0 : 2}
                            type="x"
                            removeActions={true}
                          />
                        </div>
                        <div className='sf-vector-setting'>
                          <label htmlFor='y'>
                            <MathJaxPreview math={String.raw`$y$`} />
                          </label>
                          <SFVectorInput
                            value={y}
                            disabled={true}
                            onUpdate={newVal => { }}
                            precision={isSnapToGrid ? 0 : 2}
                            type="y"
                            removeActions={true}
                          />
                        </div>
                      </div>
                      : null}
                    {questionShowMagnitudeAngle ?
                      <div>
                        <div className='sf-vector-setting'>
                          <div className="d-flex">
                            <SFTooltip text="From the positive x-axis">
                                <div>
                                    <IoInformationCircleSharp fontSize={14} color="#666" className="mr-1 cursor-pointer" />
                                </div>
                            </SFTooltip>
                            <label htmlFor='x'>
                              <MathJaxPreview math={String.raw`$angle$`} />
                            </label>
                          </div>
                          <SFVectorInput
                            value={angle}
                            disabled={true}
                            onUpdate={newVal => { }}
                            precision={1}
                            type="angle"
                            removeActions={true}
                          />
                        </div>
                        <div className='sf-vector-setting'>
                          <label htmlFor='y'>
                            <MathJaxPreview math={String.raw`$mag$`} />
                          </label>
                          <SFVectorInput
                            value={mag}
                            disabled={true}
                            onUpdate={newVal => { }}
                            precision={1}
                            type="mag"
                            canBeNegative={false}
                            removeActions={true}
                          />
                        </div>
                      </div>
                      : null}
                  </div>
                )
              }) : null}
            </div>
          : null}
        </div>

      </div>
    );
  }
);

const Vectors = ({
  _vectors,
  readOnly,
  onVectorMouseDown,
  onVectorClicked,
  onArrowClicked,
  onDragStart,
  onDragEnd,
  stepDeg,
  stepSize,
  canvasStage,
  height,
  width,
  clickedVector,
  checkBoxVector
}) => {

  if (_vectors && _vectors.length > 0) {
    return _vectors.map((vector, index) => {
      const value = { ...vector };
      if (value.type === 2) {
        return (
          <Point
            key={index}
            index={index}
            groupRef={value.ref}
            onVectorMouseDown={onVectorMouseDown}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            clickedVector={clickedVector}
            {...value}
          />
        );
      }
      return (
        <Vector
          stepDeg={value.showAngle}
          stage={canvasStage}
          posX={value.posX}
          posY={value.posY}
          magX={value.magX}
          magY={value.magY}
          name={value.name}
          x={value.x}
          y={value.y}
          stepSize={stepSize}
          textSize={Math.log(width) * 2.5}
          color={value.color ? value.color : "#0AAAFA"}
          onVectorMouseDown={onVectorMouseDown}
          onVectorClicked={onVectorClicked}
          onArrowClicked={onArrowClicked}
          clickedVector={clickedVector}
          checkBoxVector={checkBoxVector}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          index={index}
          key={index}
          groupRef={value.ref}
          latexImage={value.latexImage}
          angleOffset={value.angleOffset}
          angleOptions={{ ...value.angleOptions }}
          height={height}
          width={width}
          readOnly={readOnly}
          _showLabel={value.showLabel}
          showComponents={value.showComponents}
          labelRule={value.labelRule}
          gridWidthUnit={value.gridWidthUnit}
          gridHeightUnit={value.gridHeightUnit}
          Nvector={value.Nvector}
          strokeWidth={value.strokeWidth}
        />
      );
    });
  } else return null;
};

function VectorHelpText({ _vectors, originHelpText, BuildVectorInfo, isSnapToGrid }) {
  const [showVectorHelpText, setShowVectorHelpText] = useState(false);
  const helpTextRef = useRef(null); // Reference to scroll the help text into view
  const prevVectorsRef = useRef(_vectors);
  const handleMouseClick = (event) => {
    event.stopPropagation();
    if (showVectorHelpText) {
      setShowVectorHelpText(false);
    } else {
      setShowVectorHelpText(true);
      helpTextRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    }

  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F1") {
        event.preventDefault(); // Prevent the browser's default help action
        handleMouseClick(event);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showVectorHelpText]);

  useEffect(() => {
    if (
      JSON.stringify(prevVectorsRef.current) !== JSON.stringify(_vectors) // Check if arrays differ
    ) {
      setShowVectorHelpText(false);
      prevVectorsRef.current = _vectors;
    }
  }, [_vectors]);

  if (_vectors && _vectors.length > 0) {
    return <div>
      {/* Hover Trigger */}
      <div
        className="vectorHelpTextHover">
        <Button
          className="nocqcStyle p-0"
          icon
          style={{
            backgroundColor: 'transparent'
          }}
          onClick={handleMouseClick}
        >
          {/* <img id="vectorInfoClass" src={infoIcon} alt="Info" /> */}
          <IoMdInformationCircle fontSize={20} color="#2b9bf3" style={{ marginTop: '4px' }} />
        </Button>
      </div>

      {/* Help Text Content */}
      <div
        ref={helpTextRef}
        className={`vectorHelpTextContainer ${showVectorHelpText ? "visible" : "hidden"}`}
        style={{ overflow: showVectorHelpText ? "visible" : "hidden" }}
      >
        {/* Top Arrow */}
        <div
          style={{
            position: "absolute",
            top: "-10px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "0",
            height: "0",
            borderLeft: "10px solid transparent",
            borderRight: "10px solid transparent",
            borderBottom: "10px solid #ccc",
            zIndex: 1,
          }}
        ></div>

        {/* Main Content */}
        <div>
          <span id="canvasDescription" style={{ fontSize: "15px" }}>
            {_vectors?.length > 0 ? (
              <>
                <div>
                  The vector(s) are placed on a grid with dimensions (
                  {_vectors[0].gridWidthUnit}/{_vectors[0].gridHeightUnit}). The origin of the grid is at{" "}
                  {originHelpText(_vectors[0])}. A total of {_vectors?.length} vectors are present, listed as follows:
                </div>
                <ol style={{ margin: "0", paddingLeft: "20px" }}>
                  {_vectors.map((vector, index) => {
                    let helpText = BuildVectorInfo(vector, index, isSnapToGrid);
                    return (
                      <li key={index} style={{ marginTop: "5px" }}>
                        <MathJaxPreview math={helpText} />
                      </li>
                    )
                  })}
                </ol>
              </>
            ) : (
              "No vector information available"
            )}
          </span>
        </div>
      </div>
    </div>
  }
}

const VectorCheckbox = ({
  _vectors,
  onArrowClicked,
  checkedState
}) => {
  // check all vectors have show legend turned OFF, then simply return null
  let isAllVectorShowLegendOff = false;
  let label = "View Vectors";
  let totalShowLegendsOnCount = 0;

  if (_vectors && _vectors.length > 0) {
    let allOff = true;

    _vectors.forEach(v => {
      const showLegend = (v.showLegend !== null && v.showLegend !== undefined)
        ? v.showLegend
        : true; // default true

      if (showLegend) {
        totalShowLegendsOnCount++;
        allOff = false;
      }
    });

    isAllVectorShowLegendOff = allOff;
  }

  if (isAllVectorShowLegendOff) {
    return null;
  }

  if (totalShowLegendsOnCount === 1) {
    label = "View Vector";
  }
  console.debug("_vectors>>??", _vectors)
  if (_vectors && _vectors.length > 0) {
    return <div className="d-flex justify-content-start align-items-center w-100">
      <div className="font-weight-bold text-align-center mr-1">{label}:</div>
      <div className="d-flex justify-content-center align-items-center" style={{ gap: "8px" }}>
        {
          _vectors.sort((vecOne, vecTwo) => vecOne?.index - vecTwo?.index).map((vector, index) => {
            const value = { ...vector };
            let showLegend = (vector.showLegend !== null && vector.showLegend !== undefined) ? vector.showLegend : true;
            if (!showLegend) return null;
            return (
              <div className="d-flex justify-content-center align-items-center" key={index}>
                <FormControlLabel
                  key={'checkBox' + index}
                  className="p-0 m-0"
                  onChange={(e) => {
                    e.stopPropagation();
                    onArrowClicked(index)
                  }}
                  value={index}
                  checked={checkedState[index] !== undefined ? checkedState[index] : true}

                  control={<Checkbox
                    size="small"
                    sx={{
                      padding: 0,
                      margin: 0,
                      minWidth: 0,
                    }}
                    icon={
                      <MdCheckBoxOutlineBlank
                        style={{
                          fontSize: 18,
                          color: value.color,   // border color
                        }}
                      />
                    }
                    checkedIcon={
                      <MdCheckBox
                        style={{
                          fontSize: 18,
                          color: value.color,   // fill color when checked
                        }}
                      />
                    }
                  />}
                  label={
                    <MathJaxPreview math={`\\(${vector.name}\\)`} />
                  }
                />

              </div>
            );
          })
        }
      </div>
    </div>;
  } else return null;
};

export default Canvas;
